// Libraries
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
// Services

import { ApiService, SettingService } from '../../common/modules/core/services';
// Models
import { HolidayStudents, Excursion,AddExcursion,  WeekDetail, Weeks, Parent, ClassItem, ClassFilter, ClassList, CourseClassItem, CourseItem, CourseFilter, CourseList, ListCourseItem, Questionnarie } from '../models';
import { NonVasParent } from '../../common/modules/user/models/NonVasParent';
@Injectable()
export class HolidayService {
    // Api Domain Url
    private apiUrl = '';
    private courseUrl = '/hol/course';
    private courseClassUrl = '/hol/class/';
    private courseStudentUrl = '/hol/student/';
    private parentUrl = '/hol/parent';
    private convertParentUrl = '/hol/parent/convert';
    private parentPassword = '/hol/parent/password';
    private weekUrl = '/hol/week';
    private excursionUrl = '/hol/excursion'
    private questionnarie = "/hol/questionnaire"
    private parentEmail ='/hol/parent/email'
    private nonVasParent: NonVasParent;

    constructor(
        private apiService: ApiService,
        private settingService: SettingService
    ) {
        // Get API service domain for communate.
        this.apiUrl = this.settingService.getSetting('api_service_domain');
    }


    createCourse(courseItem: CourseItem): Observable<any> {
        const requestUrl = this.apiUrl + this.courseUrl;

        // Post content
        const body = JSON.stringify(courseItem);

        return this.apiService.post(requestUrl, body);
    }

    createCourseClass(courseClassItem: CourseClassItem): Observable<any> {
        const requestUrl = this.apiUrl + this.courseClassUrl;

        // Post content
        const body = JSON.stringify(courseClassItem);

        return this.apiService.post(requestUrl, body);
    }

    getCourseList(filter: CourseFilter): Observable<CourseList> {
        let requestUrl = this.apiUrl + this.courseUrl;
        let hasFilter = false;
        
        // Setup filter conditions
        for(let condition in filter) {
            if(filter[condition]) {
                if(hasFilter) {
                    requestUrl += '&';
                }
                else{
                    requestUrl += '?';
                    hasFilter = true;
                }

                requestUrl += condition + '=' + filter[condition];
            }
        }

        return this.apiService.get<CourseList>(requestUrl);
    }

    getCourseDetail(courseId: number): Observable<CourseList> {
        const requestUrl = this.apiUrl + this.courseUrl + '?id=' + courseId;

        return this.apiService.get<CourseList>(requestUrl);
    }
    getFullCourseList():Observable<CourseList> {
         let requestUrl = this.apiUrl + this.courseUrl;
         return this.apiService.get<CourseList>(requestUrl);
    }

    editCourse(courseItem: CourseItem): Observable<any> {
        const requestUrl = this.apiUrl + this.courseUrl;
        const body = JSON.stringify({
            id: courseItem.id,
            name: courseItem.name,
            type: courseItem.type,
            school_year: courseItem.school_year,
            start_date: courseItem.start_date,
            end_date: courseItem.end_date,
            description: courseItem.description,
            status: courseItem.status
        });
        return this.apiService.patch(requestUrl, body);
    }
    
    updateParent(nonVasParent: NonVasParent) {
        const requestUrl = this.apiUrl + this.parentUrl;

        const body = JSON.stringify(nonVasParent);

        return this.apiService.patch(requestUrl, body)
    }

    getParent(filter:any = []):Observable<Parent> {
        let requestUrl = this.apiUrl + this.parentUrl;
        let hasFilter = false;

        // Setup filter conditions
        for(let condition in filter) {
            if(filter[condition]) {
                if(hasFilter) {
                    requestUrl += '&';
                }
                else{
                    requestUrl += '?';
                    hasFilter = true;
                }

                requestUrl += condition + '=' + filter[condition];
            }
        }

        return this.apiService.get<Parent>(requestUrl)
    }

    changeParentPassword(query: any): Observable<any>{
        const requestUrl = this.apiUrl + this.parentPassword;
        const body = JSON.stringify(query);
        return this.apiService.patch(requestUrl, body)
    }

    changeParentEmail(query: any): Observable<any>{
        const requestUrl = this.apiUrl + this.parentEmail;
        const body = JSON.stringify(query);
        return this.apiService.put(requestUrl, body)
    }
    
    convertParent() {
        const requestUrl = this.apiUrl + this.convertParentUrl;
        const body = JSON.stringify({});

        return this.apiService.post(requestUrl, body)
    }
    
    getCourseClassList(filter: ClassFilter): Observable<ClassList> {
        let requestUrl = this.apiUrl + this.courseClassUrl;
        let hasFilter = false;
        
        // Setup filter conditions
        for(let condition in filter) {
            if(filter[condition]) {
                if(hasFilter) {
                    requestUrl += '&';
                }
                else{
                    requestUrl += '?';
                    hasFilter = true;
                }

                requestUrl += condition + '=' + filter[condition];
            }
        }

        return this.apiService.get<ClassList>(requestUrl);
    }

    getClassDetail(classId: number): Observable<ClassList> {
        const requestUrl = this.apiUrl + this.courseClassUrl + '?id=' + classId + '&page=1';

        return this.apiService.get<ClassList>(requestUrl);
    }

    getFullCourseClassList():Observable<ClassList> {
         let requestUrl = this.apiUrl + this.courseClassUrl;
         return this.apiService.get<ClassList>(requestUrl);
    }
    
    editClass(classItem: ClassItem): Observable<any> {
        const requestUrl = this.apiUrl + this.courseClassUrl;
        const body = JSON.stringify({
            id: classItem.id,
            thumbnail_id: classItem.thumbnail_id,
            name: classItem.name,
            room: classItem.room,
            campus_id: classItem.campus_id,
            teacher: classItem.teacher,
            max_number: classItem.max_number,
            suitable_from: classItem.suitable_from,
            suitable_to: classItem.suitable_to,
            total_cost: +classItem.total_cost,
            cost_per_week: classItem.cost_per_week,
            activities: classItem.activities,
            status: classItem.status,
            prices: classItem.prices
        });
        return this.apiService.patch(requestUrl, body);
    }


    // ───  ───────────────────────────────────────────────────────────────────────────
    // Get week
    getWeekService() {
        let requestUrl = this.apiUrl + this.weekUrl;
        return this.apiService.get(requestUrl);
    }


    // ───  ───────────────────────────────────────────────────────────────────────────
    // Add week
    addWeekService(weeks: Weeks) {
        let requestUrl = this.apiUrl + this.weekUrl;
        let body = JSON.stringify(weeks);
        return this.apiService.post(requestUrl, body);
    }

    //Edit week
    editWeekService(weeks: WeekDetail) {
        let requestUrl = this.apiUrl + this.weekUrl;
        let body = JSON.stringify(weeks);
        return this.apiService.patch(requestUrl, body);
    }

    // ───  ───────────────────────────────────────────────────────────────────────────
    // Get excursion
    getExcursionService(filter: any) {
        let requestUrl = this.apiUrl + this.excursionUrl;
        let hasFilter = false;
               // Setup filter conditions
               for(let condition in filter) {
                if(filter[condition]) {
                    if(hasFilter) {
                        requestUrl += '&';
                    }
                    else{
                        requestUrl += '?';
                        hasFilter = true;
                    }
    
                    requestUrl += condition + '=' + filter[condition];
                }
            }
    
        return this.apiService.get(requestUrl);
    }


    // ───  ───────────────────────────────────────────────────────────────────────────
    // Add excursion
    addExcursionService(excursion: AddExcursion) {
        let requestUrl = this.apiUrl + this.excursionUrl;
        let body = JSON.stringify(excursion);
        return this.apiService.post(requestUrl, body);
    }
    
    //Edit week
    editExcursionService(excursion: Excursion) {
        let requestUrl = this.apiUrl + this.excursionUrl;
        let body = JSON.stringify(excursion);
        return this.apiService.patch(requestUrl, body);
    }
    
    // ───  ───────────────────────────────────────────────────────────────────────────
    // Remove student in class
    removeStudentInClass(studentId: string, classId: number) {
        let requestUrl = this.apiUrl + this.courseStudentUrl + studentId + '/class/' + classId;
        let body = {
            "holStudentId": studentId,
            "holClassId": classId
        }
        return this.apiService.deletePost(requestUrl, body);
    }
    
    // ───  ───────────────────────────────────────────────────────────────────────────
    // Transfer waiting student in class
    transferStudentInClass(studentId: string, classId: number,status: string) {
        let requestUrl = this.apiUrl + this.courseClassUrl + classId + '/student/' + studentId;
        let body = {
            "holStudentId": studentId,
            "holClassId": classId,
            "status": status
        }
        return this.apiService.patch(requestUrl, body);
    }

    getParentById(id: any):Observable<Parent> {
        let requestUrl = this.apiUrl + this.parentUrl + '/' + id;
        return this.apiService.get<Parent>(requestUrl)
    }
    
    getQuestionnarie(){
        let requestUrl = this.apiUrl + this.questionnarie;
        return this.apiService.get(requestUrl);
    };
    
    getQuestionnarieById(id: number) {
        let requestUrl = this.apiUrl + this.questionnarie + '/' + id;
        return this.apiService.get(requestUrl);
    }

    upsertQuestionnarie(question: any) {
        let body = JSON.stringify(question);
        let requestUrl = this.apiUrl + this.questionnarie;
        return this.apiService.put(requestUrl, body);
    };
}


// WEBPACK FOOTER //
// ./src/holiday/services/HolidayService.ts